const CAMPAIGNS = "CAMPAIGNS";
const MESSAGES = "MESSAGES";
const SYSTEM_MESSAGES = "SYSTEM_MESSAGES";

const notificationSections = {
  CAMPAIGNS,
  MESSAGES,
  SYSTEM_MESSAGES
};

export default notificationSections;
